function initServiceBuilder(builder) {
  if (builder.dataset.initialized) return;
  builder.dataset.initialized = 'true';
  const form = builder.querySelector('.rd-builder__form');
  const total = builder.querySelector('[data-total]');
  const estimateLabel = builder.querySelector('[data-estimate-label]');
  const breakdown = builder.querySelector('[data-breakdown]');
  const money = (value) => new Intl.NumberFormat('en-GB', {
    style: 'currency', currency: 'GBP', maximumFractionDigits: 0
  }).format(value);

  function selected(name) {
    return form.querySelector(`input[name="${name}"]:checked`);
  }

  function render() {
    const vehicle = selected('vehicle');
    const condition = selected('condition');
    const newCarOption = form.querySelector('[data-new-car-only]');
    const isNewCar = condition.value === 'New / near perfect';
    newCarOption.disabled = !isNewCar;
    if (!isNewCar && newCarOption.checked) {
      newCarOption.checked = false;
      form.querySelector('input[name="polish"][value="No polishing"]').checked = true;
    }
    const polish = selected('polish');
    const ceramicOption = form.querySelector('[data-requires-polish]');
    ceramicOption.disabled = polish.value === 'No polishing';
    if (ceramicOption.disabled && ceramicOption.checked) {
      ceramicOption.checked = false;
      form.querySelector('input[name="protection"][value="No protection"]').checked = true;
    }
    const protection = selected('protection');
    const ppfCeramic = form.querySelector('[data-ppf-ceramic]');
    const hasPpf = protection.value.includes('PPF');
    ppfCeramic.closest('label').hidden = !hasPpf;
    ppfCeramic.disabled = !hasPpf;
    if (!hasPpf) ppfCeramic.checked = false;
    const extras = [...form.querySelectorAll('input[name="extra"]:checked')];
    const size = Number(vehicle.dataset.size);
    const servicePrice = (input) => Number(input.dataset.prices.split(',')[size]);
    form.querySelectorAll('input[data-prices]').forEach((input) => {
      const display = input.nextElementSibling.querySelector('[data-price-display]');
      if (display) display.textContent = servicePrice(input) ? money(servicePrice(input)) : '£0';
    });
    const rows = [
      ['Vehicle', vehicle.value],
      ['Paint condition', condition.value],
      ['Polishing', `${polish.value} · ${money(servicePrice(polish))}`],
      ['Protection', `${protection.value} · ${money(servicePrice(protection))}`],
      ...extras.map((input) => [input.value, money(servicePrice(input))])
    ];
    const sum = [polish, protection, ...extras].reduce((value, input) => value + servicePrice(input), 0);

    breakdown.replaceChildren(...rows.flatMap(([label, value]) => {
      const term = document.createElement('dt');
      const description = document.createElement('dd');
      term.textContent = label;
      description.textContent = value;
      return [term, description];
    }));
    total.textContent = sum ? money(sum) : '—';
    estimateLabel.textContent = sum ? 'ESTIMATE SUBJECT TO INSPECTION' : 'SELECT A SERVICE TO SEE YOUR PRICE';
  }

  form.addEventListener('submit', (event) => event.preventDefault());
  form.addEventListener('change', (event) => {
    if (event.target.matches('[data-wheel-coating]') && event.target.checked) {
      form.querySelectorAll('[data-wheel-coating]').forEach((input) => {
        if (input !== event.target) input.checked = false;
      });
    }
    render();
  });
  builder.querySelector('[data-reset]').addEventListener('click', () => {
    form.reset();
    render();
  });
  render();
}

document.querySelectorAll('[data-service-builder]').forEach(initServiceBuilder);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-service-builder]').forEach(initServiceBuilder);
});
